module.exports = __webpack_public_path__ + "media/images/pepsi_digin_brunch_lv/shape-3-6aa2292841757c12952bc23b8508b60b.png";